import type { ExamRecord } from '@/services/examService';

function getStatusCandidates(record: ExamRecord): string[] {
  return [
    record.reportStatus,
    record.status,
    record.studyStatusDescription,
  ]
    .map((value) => value?.trim())
    .filter((value): value is string => Boolean(value));
}

export const REPORT_AVAILABLE_STATUSES = new Set([
  'Signed1',
  'ExamDone',
  'RepeatDone',
  'TentativelySched1',
  'ExamDoneTechOnly',
  'ExtReportVerified',
]);

export function hasResultsAvailableStatus(record: ExamRecord): boolean {
  return getStatusCandidates(record).some((status) => REPORT_AVAILABLE_STATUSES.has(status));
}

/**
 * True when the report can actually be opened, per PortalApi's own report gate.
 * Falls back to the status allowlist when the API predates `reportAvailable`, so an older
 * backend keeps the previous behaviour instead of emptying the list.
 */
export function hasOpenableReport(record: ExamRecord): boolean {
  return record.reportAvailable ?? hasResultsAvailableStatus(record);
}
